module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Adopted"
  }, [(_vm.adopted) ? _c('slider', {
    attrs: {
      "items": _vm.items
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-469d2ee2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Adopted.vue
// module id = 837
// module chunks = 1